






































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';

import PaginationInterface from '@core/interfaces/pagination-interface';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';

import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';

import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';

import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import moment from 'moment';
import Table from '@shared/components/tables/table.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import { mixins } from 'vue-class-component';
import MembershipPaymentForm from '@subscriptions/components/forms/admin/membership-payment-form.vue';
import AccessControlBadgeForm from '@access-control/components/access-control-badge-form.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import {
  accessControlBadgeDisplayFields,
  accessControlBadgeFilters,
} from '@/config/access_control_options';
import { AccessControlBadge } from '@access-control/interfaces/access-control-badge';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import AuthorizationHelper from '@auth/services/authorization.helper';
import ReplaceAccessControlBadgeModal from '@/app/modules/access-control/components/modals/replace-access-control-badge-modal/replace-access-control-badge-modal.vue';
import BlockAccessControlBadgeModal from '@/app/modules/access-control/components/modals/block-access-control-badge-modal/block-access-control-badge-modal.vue';
import BpcAccessControlEventTable from '@access-control/components/tables/access-control-event-table.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import ResyncFinddocBadgeModal from '@access-control/components/modals/resync-finddoc-badge-modal/resync-finddoc-badge-modal.vue';
library.add(faRetweet);

@Component({
  name: 'bpc-access-control-badge-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-table': Table,
    'bpc-access-control-badge-form': AccessControlBadgeForm,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-contact-link': DisplayContactLink,
    'bpc-membership-payment-form': MembershipPaymentForm,
    'bpc-page-title': BpcPageTitle,
    'bpc-drawer-modal': DrawerModal,
    'bpc-replace-access-control-badge-modal': ReplaceAccessControlBadgeModal,
    'bpc-block-access-control-badge-modal': BlockAccessControlBadgeModal,
    'bpc-access-control-event-table': BpcAccessControlEventTable,
    'bpc-resync-finddoc-badge-modal': ResyncFinddocBadgeModal,
  },
})
export default class AccessControlBadgeList extends mixins(SendMessageUsingTemplateMixin) {
  declare $refs: SendMessageUsingTemplateMixin['$refs'] & {
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    hardDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    recoverConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkHardDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    accessControlBadgeForm: InstanceType<typeof AccessControlBadgeForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      saving: boolean;
    };
  };

  // PROPS
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    contact_id: number | number[];
    status: string;
  };
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCreateButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showSoftDeleteButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCancelButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showRecoverButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showHardDeleteButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showEditButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showBulkSoftDeleteButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showBulkRecoverButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showBulkCancelButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showBulkHardDeleteButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showResyncFinddocButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;

  // DATA
  loading: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  accessControlBadgeItems: AccessControlBadge[] = [];

  submittedSearch = '';
  selectedContacts = [];
  selectedStatus = '';
  selectedBadgeId = null;
  selectedSubscription = null;
  public selectedRowEntity = null;
  showReplaceAccessControlBadgeModal = false;
  showBlockAccessControlBadgeModal = false;
  showResyncFinddocBadgeModal = false;
  dataTab = 'Data';
  syncTab = 'Sync';

  get rowActions() {
    return {
      cancel: {
        permissions: ['cancel'],
        activated: false,
        show: this.showCancelActionButton,
      },
      edit: {
        permissions: ['update'],
        activated: false,
        show: this.showEditActionButton,
      },
      softDelete: {
        permissions: ['destroy'],
        activated: false,
        show: this.showSoftDeleteActionButton,
      },
      hardDelete: {
        permissions: ['delete'],
        activated: false,
        show: this.showHardDeleteActionButton,
      },
      recover: {
        permissions: ['recover'],
        activated: false,
        show: this.showRecoverActionButton,
      },
      block: {
        permissions: ['update'],
        activated: false,
        show: this.showBlockActionButton,
      },
      unblock: {
        permissions: ['update'],
        activated: false,
        show: this.showUnblockActionButton,
      },
      replace: {
        permissions: ['update'],
        activated: false,
        show: this.showReplaceActionButton,
      },
      resyncFinddoc: {
        permissions: ['update'],
        activated: false,
        show: this.showResyncFinddocActionButton,
      },
    };
  }

  pageActions = {
    bulkDelete: {
      activated: false,
      type: 'action',
      icon: 'trash', //'times',
      variant: 'danger',
      text: 'delete',
      show: this.showBulkHardDeleteActionButton,
      event: 'bulk-delete',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_destroy'],
    },
    bulkRecover: {
      activated: false,
      type: 'action',
      icon: 'undo',
      variant: 'info',
      text: 'recover',
      show: this.showBulkRecoverActionButton,
      event: 'bulk-recover',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_recover'],
    },
    bulkCancel: {
      activated: false,
      type: 'action',
      icon: 'ban', //'times',
      variant: 'danger',
      text: 'cancel',
      show: this.showBulkCancelActionButton,
      event: 'bulk-cancel',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'],
    },
    bulkSoftDelete: {
      activated: false,
      type: 'action',
      icon: 'trash',
      variant: 'danger',
      text: 'soft-delete',
      show: this.showBulkSoftDeleteActionButton,
      event: 'bulk-soft-delete',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_delete'],
    },
    create: {
      activated: false,
      type: 'action',
      icon: 'plus',
      variant: 'success',
      text: 'create-new',
      show: this.showCreateActionButton,
      event: 'create',
      selectElements: false,
      tag: 'right',
      permissions: ['store'],
    },
  };
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  gridCols = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  showDrawerSection = false;
  formModel: Partial<AccessControlBadge> = {};
  timestamp = moment().unix();

  // MOVE to TRASH
  showBulkMoveToTrashModal = false;
  showBulkRecoverModal = false;
  selection = [];
  filterModel = null;
  entityName = 'access-control-badge';
  pluralEntityName = 'access-control-badges';
  permissionEntityNameToUse = 'access_control_badges';
  dataToShowInBulkReports = [];
  checkedAllEntities = false;
  searchAndOrderQueryParams = {};
  canceling: boolean = false;

  accessControlBadgeFieldsToShow = [
    {
      key: 'code',
      headerLabel: 'global.access_control_badge.code.header_label',
    },
    {
      key: 'badge_number',
      headerLabel: 'global.access_control_badge.badge_number.header_label',
    },
    {
      key: 'type',
      headerLabel: 'global.access_control_badge.type.header_label',
    },
    {
      key: 'contact.fullname',
      headerLabel: `global.access_control_badge.contact_id.header_label`,
    },
    {
      key: 'primary',
      headerLabel: `global.access_control_badge.primary.label`,
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
    },
  ];
  // LIFECYCLE

  // created() {}
  mounted() {
    this.checkPermissionsForActions();
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getBadgesIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get showCreateActionButton() {
    return !this.trashFilterSelected && this.showCreateButton && !this.disabled;
  }

  get showBulkSoftDeleteActionButton() {
    return !this.trashFilterSelected && this.showBulkSoftDeleteButton && !this.disabled;
  }

  get showBulkCancelActionButton() {
    return !this.trashFilterSelected && this.showBulkCancelButton && !this.disabled;
  }

  get showBulkRecoverActionButton() {
    return this.trashFilterSelected && this.showBulkRecoverButton && !this.disabled;
  }

  get showBulkHardDeleteActionButton() {
    return this.trashFilterSelected && this.showBulkHardDeleteButton && !this.disabled;
  }

  get showCancelActionButton() {
    return !this.trashFilterSelected && this.showCancelButton && !this.disabled;
  }

  get showEditActionButton() {
    return !this.trashFilterSelected && this.showEditButton && !this.disabled;
  }

  get showSoftDeleteActionButton() {
    return !this.trashFilterSelected && this.showSoftDeleteButton && !this.disabled;
  }

  get showRecoverActionButton() {
    return this.trashFilterSelected && this.showRecoverButton && !this.disabled;
  }

  get showBlockActionButton() {
    return true; //#FixMe later
  }

  get showUnblockActionButton() {
    return true; //#FixMe later
  }

  get showReplaceActionButton() {
    return true; //#FixMe later
  }

  get showResyncFinddocActionButton(): boolean {
    return (
      this.useFinddoc &&
      this.showResyncFinddocButton &&
      !this.disabled &&
      this.$authorizationService.hasPermission('manage_access_control_badges')
    );
  }

  get showHardDeleteActionButton() {
    return this.trashFilterSelected && this.showHardDeleteButton && !this.disabled;
  }

  get useFinddoc(): boolean {
    return (
      this.$store.getters['centerSettings/accessControlConfig']?.access_control_service ===
      'finddoc'
    );
  }

  get modalTitle() {
    if (this.formModel && this.formModel.id) {
      return (
        this.$t('global.modals.edit') + ' ' + this.$t('global.models.' + this.entityName + '.name')
      );
    } else {
      return (
        this.$t('global.modals.create') +
        ' ' +
        this.$t('global.models.' + this.entityName + '.name')
      );
    }
  }

  get cancelModalTitle() {
    const cancelType = this.selectedRowEntity ? 'cancel' : 'bulk-cancel';
    return this.$t(`global.access_control_badge.${cancelType}.title`, {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get cancelModalBody() {
    const cancelType = this.selectedRowEntity ? 'cancel' : 'bulk-cancel';
    return this.$t(`global.access_control_badge.${cancelType}.body`, {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get saving() {
    return this.$refs.accessControlBadgeForm?.saving || false;
  }

  get formCancelPortalTarget(): string {
    return `access-control-badge-form-cancel-portal-target-${this.timestamp}`;
  }

  get formActionsPortalTarget(): string {
    return `access-control-badge-form-actions-portal-target-${this.timestamp}`;
  }

  get filtersConfig() {
    return accessControlBadgeFilters;
  }
  get displayConfig() {
    return accessControlBadgeDisplayFields;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.submittedSearch,
      ...this.selectedContacts,
      this.selectedStatus,
    ].join('--');
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'access-control-badge';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get hardDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-hard-delete-modal',
      title: this.$t('global.modals.delete.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.delete.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.permanent_delete') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get recoverConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-recover-modal',
      title: this.$t('global.modals.recover.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.recover.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.recover') as string,
      acceptButtonVariant: 'info',
    };
  }

  get bulkHardDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-bulk-hard-delete-modal',
      title: this.$t('global.modals.bulk-delete.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.bulk-delete.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.permanent_delete') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get selectionCount(): number {
    return (this.checkedItems || []).length;
  }

  get trashFilterSelected(): boolean {
    return this.selectedStatus === 'trash';
  }

  // METHODS
  checkPermissionsForActions() {
    Object.entries(this.pageActions)?.forEach(([key, value]) => {
      const permissions = [];
      this.pageActions[key]['permissions']?.forEach(permissionName => {
        permissions.push(
          {
            name: AuthorizationHelper.getPermissionName(
              permissionName,
              (this.permissionEntityNameToUse
                ? this.permissionEntityNameToUse
                : this.pluralEntityName
              ).replace('-', '_'),
            ),
          },
          {
            name: AuthorizationHelper.getPermissionName(
              permissionName,
              (this.permissionEntityNameToUse
                ? this.permissionEntityNameToUse
                : this.pluralEntityName
              ).replace('-', '_'),
              true,
            ),
          },
        );
      });
      this.pageActions[key]['activated'] = this.$authorizationService.hasPermissions(permissions);
    });

    Object.entries(this.rowActions).forEach(([key, value]) => {
      const permissions = [];
      this.rowActions[key]['permissions'].forEach(permissionName => {
        permissions.push(
          {
            name: AuthorizationHelper.getPermissionName(
              permissionName,
              (this.permissionEntityNameToUse
                ? this.permissionEntityNameToUse
                : this.pluralEntityName
              ).replace('-', '_'),
            ),
          },
          {
            name: AuthorizationHelper.getPermissionName(
              permissionName,
              (this.permissionEntityNameToUse
                ? this.permissionEntityNameToUse
                : this.pluralEntityName
              ).replace('-', '_'),
              true,
            ),
          },
        );
      });
      this.rowActions[key]['activated'] = this.$authorizationService.hasPermissions(permissions);
    });
  }

  onPageAction($event: string) {
    switch ($event) {
      case 'bulk-delete':
        this.clickOnBulkHardDelete();
        break;
      case 'bulk-soft-delete':
        this.clickOnBulkSoftDelete();
        break;
      case 'bulk-recover':
        this.clickOnBulkRecover();
        break;
      case 'bulk-cancel':
        this.clickOnBulkCancel();
        break;
      case 'create':
        this.clickOnCreate();
        break;
    }
  }

  onOpenCancelModal() {
    this.$bvModal.show('modal-cancel-access-control-badges');
  }

  onCloseCancelModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide('modal-cancel-access-control-badges');
  }

  onConfirmBulkCancelModal() {
    this.canceling = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('access-control-badge');
    this.$bpcApi
      .put(basePath + '/bulk-cancel', {
        modelIds: this.checkedItemsIds,
      })
      .subscribe(
        res => {
          this.getAccessControlBadges();
          this.canceling = false;
          this.$bvModal.hide('modal-cancel-access-control-badges');
        },
        error => {
          this.canceling = false;
          this.$bpcMessage.showErrorMessage({
            text: 'global.access_control_badge.bulk-cancel.error',
          });
        },
      );
  }

  onConfirmRowCancelModal() {
    this.canceling = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('access-control-badge');
    const url = basePath + `/${this.selectedRowEntity.id}/cancel`;
    this.$bpcApi.put(url).subscribe(
      res => {
        this.selectedRowEntity = null;
        this.getAccessControlBadges();
        this.canceling = false;
        this.$bvModal.hide('modal-cancel-access-control-badges');
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
      },
      error => {
        this.canceling = false;
        this.$bpcMessage.showErrorMessage({ text: 'global.access_control_badge.cancel.error' });
      },
    );
  }

  onFormSave(next: string = '') {
    this.$refs.accessControlBadgeForm.saveEntity();
  }

  onFormClose() {
    this.showDrawerSection = false;
  }

  clickOnEdit(data) {
    this.formModel = data.item;
    this.showDrawerSection = true;
  }

  clickOnUnblock(item) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('access-control-badges')}/${
      item.id
    }/unblock-badge`;

    this.$bpcApi.post(path).subscribe(
      res => {
        this.showDrawerSection = false;
        this.getBadgesIfStopChanging();
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error' });
      },
    );
  }

  clickOnReplace(item) {
    this.showReplaceAccessControlBadgeModal = true;
    this.selectedRowEntity = item;
  }

  clickOnResyncFinddoc(item) {
    console.log(item.id);
    this.showResyncFinddocBadgeModal = true;
    this.selectedBadgeId = item.id;
  }

  onCloseResyncFinddocBadgeModal() {
    this.showResyncFinddocBadgeModal = false;
    this.selectedBadgeId = null;
  }

  onResyncedFinddocBadgeModal() {
    this.onCloseResyncFinddocBadgeModal();
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.getBadgesIfStopChanging();
  }

  onErrorSyncingFinddocBadgeModal() {
    this.onCloseResyncFinddocBadgeModal();
    this.$bpcMessage.showErrorMessage({ text: 'global.generic.server_error' });
  }

  clickOnBlock(item) {
    this.showBlockAccessControlBadgeModal = true;
    this.selectedRowEntity = item;
  }

  onCloseReplaceAccessControlBadgeModal() {
    this.showReplaceAccessControlBadgeModal = false;
  }

  onReplacedAccessControlBadgeModal() {
    this.showReplaceAccessControlBadgeModal = false;
    this.getBadgesIfStopChanging();
  }

  onCloseBlockAccessControlBadgeModal() {
    this.showBlockAccessControlBadgeModal = false;
    debugger;
  }

  onBlockAccessControlBadgeModal() {
    this.showBlockAccessControlBadgeModal = false;
    this.getBadgesIfStopChanging();
    this.showDrawerSection = false;
  }

  clickOnCancel(item) {
    this.selectedRowEntity = item;
    this.onOpenCancelModal();
  }

  clickOnBulkCancel() {
    this.selectedRowEntity = null;
    this.onOpenCancelModal();
  }

  onCheckAll(val: boolean) {
    this.checkedAllEntities = val;
  }

  get checkedItems() {
    return this.accessControlBadgeItems.filter(item => item.checked) || [];
  }

  get checkedItemsIds() {
    return this.checkedItems.map(item => item.id) || [];
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.submittedSearch = this.initialFilters?.search || '';
      this.selectedStatus = this.initialFilters?.status || '';
      if (this.initialFilters?.contact_id) {
        if (Array.isArray(this.initialFilters?.contact_id)) {
          this.selectedContacts = this.initialFilters?.contact_id;
        } else {
          this.selectedContacts = [this.initialFilters?.contact_id];
        }
      } else {
        this.selectedContacts = [];
      }
    }
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();
      if (!this.submittedSearch) {
        this.submittedSearch = urlParams?.search || '';
      }

      if (!this.selectedStatus) {
        this.selectedStatus = urlParams?.status || '';
      }

      if (!this.selectedContacts) {
        if (urlParams?.contact_id) {
          if (Array.isArray(urlParams?.contact_id)) {
            this.selectedContacts = urlParams?.contact_id;
          } else {
            this.selectedContacts = [urlParams?.contact_id];
          }
        } else {
          this.selectedContacts = [];
        }
      }
    }
  }

  getBadgesIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getAccessControlBadges();
      }
    }, 300);
  }

  async getAccessControlBadges() {
    this.loading = true;
    this.checkedAllEntities = false;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('access-control-badge');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.accessControlBadgeItems = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }

  getQueryParams() {
    return {
      order_by: 'code',
      order_direction: 'desc',
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.submittedSearch,
      contact_id: this.selectedContacts?.length ? this.selectedContacts : null,
      status: this.selectedStatus,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  clickOnReload() {
    this.getBadgesIfStopChanging();
  }

  clickOnCreate() {
    this.formModel = {};
    this.showDrawerSection = true;
  }

  clickOnSoftDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.id);
  }

  clickOnHardDelete(item) {
    this.$refs.hardDeleteConfirmationModal.onOpenModal(item.id);
  }

  clickOnRecover(item) {
    this.$refs.recoverConfirmationModal.onOpenModal(item.id);
  }

  onEntitySaved() {
    this.$emit('entity-saved');
    this.getBadgesIfStopChanging();
  }

  onSuccessSoftDelete() {
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getBadgesIfStopChanging();
  }

  onSuccessBulkRecover() {
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.getBadgesIfStopChanging();
  }

  onSuccessRecover() {
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.$refs.recoverConfirmationModal.onCloseModal();
    this.getBadgesIfStopChanging();
  }

  onSuccessHardDelete() {
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.$refs.hardDeleteConfirmationModal.onCloseModal();
    this.getBadgesIfStopChanging();
  }

  onSuccessBulkSoftDelete() {
    this.getBadgesIfStopChanging();
  }

  onSuccessBulkHardDelete() {
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.$refs.bulkHardDeleteConfirmationModal.onCloseModal();
    this.getBadgesIfStopChanging();
  }

  onCloseModal() {
    this.formModel = null;
    this.showDrawerSection = false;
  }

  clickOnBulkSoftDelete() {
    this.selection = this.checkedItemsIds;
    this.filterModel = this.getQueryParams();
    this.dataToShowInBulkReports = [['code']];
    this.searchAndOrderQueryParams = this.getQueryParams();
    this.showBulkMoveToTrashModal = true;
  }

  onCloseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }

  clickOnBulkHardDelete() {
    this.$refs.bulkHardDeleteConfirmationModal.onOpenModal(this.checkedItemsIds);
  }

  clickOnBulkRecover() {
    this.selection = this.checkedItemsIds;
    this.filterModel = this.getQueryParams();
    this.dataToShowInBulkReports = [['code']];
    this.searchAndOrderQueryParams = this.getQueryParams();
    this.showBulkRecoverModal = true;
  }

  onCloseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  // WATCHERS

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getBadgesIfStopChanging();
    }
  }

  @Watch('selectedStatus')
  onChangeStatusFilter(val) {
    this.checkPermissionsForActions();
    this.$set(this.pageActions['bulkDelete'], 'show', this.showBulkHardDeleteActionButton);
    this.$set(this.pageActions['bulkRecover'], 'show', this.showBulkRecoverActionButton);
    this.$set(this.pageActions['bulkCancel'], 'show', this.showBulkCancelActionButton);
    this.$set(this.pageActions['bulkSoftDelete'], 'show', this.showBulkSoftDeleteActionButton);
    this.$set(this.pageActions['create'], 'show', this.showCreateActionButton);
  }
}
